import { Component, input } from '@angular/core';

@Component({
  selector: 'app-primeng-spinner',
  template: `
    <div class="flex justify-content-center align-items-center w-full" *ngIf="show()">
      <p-progressSpinner 
        [style]="style()" 
        [strokeWidth]="strokeWidth()" 
        [fill]="fill()" 
        [animationDuration]="animationDuration()">
      </p-progressSpinner>
    </div>
  `,
  styles: [],
  standalone: false,
})
export class PrimengSpinnerComponent {
  show = input<boolean>(false);
  style = input<any>({ width: '50px', height: '50px' });
  strokeWidth = input<string>('8');
  fill = input<string>('transparent');
  animationDuration = input<string>('.5s');
}
